import { Injectable } from "@angular/core";
import { Observable ,  Subject ,  BehaviorSubject } from "rxjs";
import { NotifierService } from "./notifierService/notifier.service";
import { Component, ViewContainerRef, ViewEncapsulation } from "@angular/core";
import {
	Overlay,
	overlayConfigFactory,
	OverlayConfig,
	OverlayContext,
} from "ngx-modialog-7";
import { Modal, BSModalContext } from "ngx-modialog-7/plugins/bootstrap";
import { UtilityScripts } from "../helpers/utility-scripts";
import {
	DialogModalContext,
	DialogModal,
} from "../directives/dialog-popup/dialog-modal-popup.directive";
import { ApplicationModel } from "../core/models/application.model";

@Injectable()
export class ModalPopupService extends NotifierService {
	private context: any;
	public ClosePopup: Subject<string>;
	private dialogRef;
	private _modal;
	constructor(public modal: Modal) {
		super();
	}

	public openPopup(popupData) {
		console.log(popupData);
		this.ClosePopup = new BehaviorSubject<string>(null);
		let _owner: any = this;
		this.context = null;
		if(!this.dialogRef){ //To prevent opening multiple popup instances
		// console.log('this.popupData.bodyText  ', popupData.bodyText );
		this.dialogRef = this.modal
			.alert()
			.size(popupData.size || "lg")
			.showClose(popupData.showClose || false)
			.okBtn(
				UtilityScripts.addEnAndEmDash(
					UtilityScripts.removeHTMLTags(popupData.buttonLabel)
				)
			)
			.okBtnClass(popupData.disableOk ? "disabled" : "")
			.headerClass(
				`modal-header direction-${ApplicationModel.instance.flowDirection}`
			)
			.title(
				UtilityScripts.addEnAndEmDash(
					UtilityScripts.removeHTMLTags(popupData.title)
				)
			)
			.bodyClass(
				`modal-body direction-${ApplicationModel.instance.flowDirection}`
			)
			.body(popupData.bodyText)
			.open();
			_owner._modal = this.dialogRef;
			_owner.context = this.dialogRef.context;
			this.dialogRef.context.isBlocking = true; // To remove outside click close
			this.dialogRef.context.keyboard = []; // To remove escape keypress
			this.dialogRef.onDestroy.subscribe((result) => _owner.closeDialogue()); //listens popup close
			if (popupData.fontSize) {
				setTimeout(
					function () {
						let ele: any = document.getElementsByTagName("modal-content")[0];
						ele.style.fontSize = popupData.fontSize;
					},
					100,
					popupData
				);
			}
	}
	}
	public openIAgreePopup(popupData) {
		let _owner: any = this;
		this.dialogRef = this.modal
			.confirm()
			.size(popupData.size || "lg")
			.okBtn(
				UtilityScripts.addEnAndEmDash(
					UtilityScripts.removeHTMLTags(popupData.exitButtonLabel)
				)
			)
			.okBtnClass(popupData.disableOk ? "disabled" : "")
			.cancelBtn(
				UtilityScripts.addEnAndEmDash(
					UtilityScripts.removeHTMLTags(popupData.printButtonLabel)
				)
			)
			.cancelBtnClass(popupData.disableOk ? "disabled" : "")
			.headerClass(
				`modal-header direction-${ApplicationModel.instance.flowDirection}`
			)
			.title(
				UtilityScripts.addEnAndEmDash(
					UtilityScripts.removeHTMLTags(popupData.title)
				)
			)
			.bodyClass(
				`modal-body direction-${ApplicationModel.instance.flowDirection}`
			)
			.body(popupData.bodyText)
			.open();
			setTimeout(() => {
				let modelFooter = document.getElementsByClassName("modal-footer")[0];
				modelFooter
					.querySelectorAll("button")[0]
					.addEventListener("click", function () {
						_owner._notifier.next("print");
					});
				modelFooter
					.querySelectorAll("button")[1]
					.addEventListener("click", function () {
						_owner._notifier.next("close");
					});
			}, 500);
			_owner._modal = this.dialogRef;
			_owner.context = this.dialogRef.context;
			this.dialogRef.context.isBlocking = true; // To remove outside click close
			this.dialogRef.context.keyboard = []; // To remove escape keypress
	}
	enableOkButton() {
		this.context.buttons.forEach((btn) => (btn.cssClass = ""));
	}
	closeDialogue() {
		if (this.ClosePopup) {
			this.ClosePopup.next("close");
			this._notifier.next(`close`);
			this.ClosePopup = null;
			this.dialogRef = null;
		}
	}
	public closePopup() {
		console.log("Close Popup");
		if(this._modal){
		this._modal.dismiss();
		}
	}
	public openDialogPopup(popupData) {
		let _owner: any = this;
		this.dialogRef = this.modal
			.open(
				DialogModal,
				overlayConfigFactory(
					{
						title: popupData.title,
						body: popupData.body,
						footer: popupData.footer,
						isMaxIdlePopup: popupData.isMaxIdlePopup,
					},
					BSModalContext
				)
			);
			_owner._modal = this.dialogRef;
			_owner.context = this.dialogRef.context;
			this.dialogRef.onDestroy.subscribe((result) => _owner.closeDialogue());
	}
	public closeDialogPopup() {
		this._modal.dismiss();
	}
}
